import { render, staticRenderFns } from "./status.vue?vue&type=template&id=cb0bad3c&scoped=true&"
import script from "./status.vue?vue&type=script&lang=js&"
export * from "./status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0bad3c",
  null
  
)

export default component.exports